import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateContactForLead as UpdateContactForLeadMutation,
    UpdateContactForLeadVariables as UpdateContactForLeadMutationVariables,
    ContactUpdateInput,
} from 'nutshell-graphql-types';

import {refetchAccountsAndContactsQueries} from '../../helpers';

import UPDATE_CONTACT_FOR_LEAD from '../mutations/update-contact-for-lead.graphql';

export const useUpdateContactForLead = (
    leadId: string
): {
    updateContact: (arg1: ContactUpdateInput) => Promise<any>;
    isLoading: boolean;
} => {
    const [updateContact, {loading}] = useMutation<
        UpdateContactForLeadMutation,
        UpdateContactForLeadMutationVariables
    >(UPDATE_CONTACT_FOR_LEAD);

    return {
        updateContact: (input: ContactUpdateInput) =>
            updateContact({
                variables: {input},
                refetchQueries: refetchAccountsAndContactsQueries({leadId}),
                awaitRefetchQueries: true,
            }),
        isLoading: loading,
    };
};
